/**
 * @file Card atom — content surface primitive.
 * @description Structured atom: parts re-exported from the vendored Gluestack
 * family; the only sanctioned import path for app code (RFC §3).
 * @module components/atoms/Card
 */
export { Card } from "@/components/ui/card";
